import React from "react";
import { NavLink, Link } from "react-router-dom";

import BaseComponent from "../../BaseComponent.js";
import styled from "styled-components";
import NanoFlex from "../../Global/NanoFlex.js";
import Type from "../../Global/Typography.js";
import SimpleButton from "../../Buttons/SimpleButton.js";

const StyledMenuMobile = styled(NanoFlex)`
  display: ${(props) => (props.show ? "flex" : "none")};
  z-index: 7;
  background: rgb(162 173 234 / 47%);
  backdrop-filter: ${(props) => props.theme.blur};
  position: fixed;
  width: fit-content;
  top: 0;
  left: unset;
  right: 0;
  animation: slide-bottom 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  padding: 80px 50px 50px 50px;

  .navItemsWrapper {
    display: ${(props) => (props.formationDetail ? "none" : "flex")};
    gap: 32px;

    .navItemsList {
      flex-grow: 1;
      overflow-y: auto;
      .navItem {
        margin-bottom: 24px;
        height: auto;
        justify-content: flex-end;
        a {
          text-decoration: none;
          p {
            color: ${(props) => props.theme.color.primaryColors.white};
            text-transform: none;
          }
        }
        .activeNavItem {
          pointer-events: none;
          p {
            color: ${(props) => props.theme.color.primaryColors.labelPurple};
            font-weight: bold;
          }
        }
      }

      .iconNavItem {
        margin-right: 16px;
        width: auto;
        &:last-child {
          margin-right: 0;
        }
      }

      .navIconsWrapper {
        margin-top: 16px;
      }
    }
    .languagesList {
      width: auto;
      height: auto;
      background-color: ${(props) => props.theme.color.primaryColors.lighterYellow};
      padding: 8px 10px;
      border-radius: 5px;
      .langItem {
        margin-right: 8px;
        cursor: pointer;
        padding: 5px 10px;

        p {
          color: ${(props) => props.theme.color.primaryColors.secFontColor};
          font-size: 12px;
        }

        &:last-child {
          margin-right: 0;
        }
      }
      .activeLangItem {
        pointer-events: none;

        p {
          font-weight: bold;
        }
      }
    }
  }

  .sayHiBtn {
    height: auto;

    a {
      width: 100%;
    }

    .button {
      width: 100%;
      button {
        width: 100%;
        justify-content: center;
        text-align: center;
        box-shadow: ${(props) => props.theme.lightShaddow};
      }
    }
  }

  @keyframes slide-bottom {
    0% {
      transform: translateX(200px);
    }
    100% {
      transform: translateX(0px);
    }
  }
`;

class MenuMobile extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      selected: this.props.selected ? this.props.selected : 1,
    };
  }

  componentDidMount() {
    super.componentDidMount();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.selected !== this.state.selected) this.props.onMenuBurgerOpenChange(false);
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  //LANGUAGUE
  onHeaderLanguageChange = () => {
    this.getAllComponentsData();
  };

  changeLanguage = (langId) => {
    window.dispatchEvent(new CustomEvent("languageChange", { detail: langId }));
  };
  //END LANGUAGUE
  onSelectClick = (v) => {
    this.setState({ selected: v });
  };

  render() {
    let langId = this.getLanguage();
    return (
      <StyledMenuMobile className="menuMobile" show={this.props.menuBurgerOpen} justifyContent="flex-start" alignItems="flex-start">
        <NanoFlex className="navItemsWrapper" flexDirection="column">
          <NanoFlex className="navItemsList" flexDirection="column" justifyContent="flex-start">
            <NanoFlex className="navItem">
              <NavLink to="/about-us" exact activeClassName="activeNavItem">
                <Type.p>{this.translation.navBar.aboutUs}</Type.p>
              </NavLink>
            </NanoFlex>

            <NanoFlex className="navItem">
              <NavLink to="/recrutamento" exact activeClassName="activeNavItem">
                <Type.p>{this.translation.navBar.recruitment}</Type.p>
              </NavLink>
            </NanoFlex>

            <NanoFlex className="navItem">
              <NavLink to="/assessment" exact activeClassName="activeNavItem">
                <Type.p>{this.translation.navBar.assessment}</Type.p>
              </NavLink>
            </NanoFlex>
          </NanoFlex>

          <NanoFlex className="sayHiBtn">
            <Link to="#contacts">
              <SimpleButton label="Say Hi!"></SimpleButton>
            </Link>
          </NanoFlex>
          <NanoFlex className="languagesList">
            <NanoFlex className={`langItem ${langId === null ? "activeLangItem" : ""}`} onClick={() => this.changeLanguage(null)}>
              <Type.p>PT</Type.p>
            </NanoFlex>

            <NanoFlex className={`langItem ${langId === 2 ? "activeLangItem" : ""}`} onClick={() => this.changeLanguage(2)}>
              <Type.p>ENG</Type.p>
            </NanoFlex>
          </NanoFlex>
        </NanoFlex>
      </StyledMenuMobile>
    );
  }
}

//Set default props
MenuMobile.defaultProps = {
  show: false,
};

export default MenuMobile;

// --- // Documentation // --- //
/*
import MenuMobile from './NavBar/MenuMobile.js';

<MenuMobile />
*/
